import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterWithImageComponent } from './auth/register/register-with-image.component';
import { ToastrModule } from 'ngx-toastr';
import { NgToggleModule } from 'ng-toggle-button';

import { AuthService } from './shared/services/firebase/auth.service';
import { AdminGuard } from './shared/guard/admin.guard';
import { SecureInnerPagesGuard } from './shared/guard/SecureInnerPagesGuard.guard';
import { CookieService } from 'ngx-cookie-service';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { UploadModule } from '@progress/kendo-angular-upload';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { AngularFireStorageModule } from '@angular/fire/storage';




import { MantbasicaService } from "./shared/services/mantbasica.service";
import { MantablasLibreria } from "./shared/services/mantbasica.libreria";
import localeEs from '@angular/common/locales/es'
import { registerLocaleData } from '@angular/common';
import { DragulaModule } from 'ng2-dragula';
import { DataTablesModule } from 'angular-datatables';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';


import { AngularSvgIconModule } from 'angular-svg-icon';


registerLocaleData(localeEs, 'es')




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterWithImageComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    DialogsModule,
    DropDownsModule,
    NotificationModule,
    GridModule,
    LayoutModule,
    ChartsModule,
    UploadModule,
    InputsModule,
    GaugesModule,
    AngularFireStorageModule,
    NgToggleModule,
    DragulaModule.forRoot(),
    EditorModule,
    ScrollViewModule,
    AngularSvgIconModule.forRoot()
  ],
  providers: [AuthService, AdminGuard, SecureInnerPagesGuard, CookieService, MantbasicaService, MantablasLibreria, { provide: LOCALE_ID, useValue: 'es' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
